module.exports = __webpack_public_path__ + "static/media/before-you-start.aaf181e0.svg";